import type { ReactNode } from 'react';
import { Label } from './label';
import { cn } from '@/lib/utils';
export function FormField({ label, htmlFor, error, required, description, children, className }: { label: string; htmlFor: string; error?: string; required?: boolean; description?: string; children: ReactNode; className?: string }) {
  return <div className={cn('space-y-1.5', className)}><Label htmlFor={htmlFor} required={required}>{label}</Label>{children}{description && !error && <p className="text-xs text-slate-500">{description}</p>}{error && <p className="text-xs text-red-600">{error}</p>}</div>;
}
